/* src/utils/cn.ts */
import { clsx, type ClassValue } from 'clsx';

/**
 * Utility for composing class names safely with clsx
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
